module.exports = new __parcel__URL__("crystaldetonation.2ca191c4.png").toString();